// extracted by mini-css-extract-plugin
export default {"external":"aEvec3","offerTitle":"bEvec3"};